<template>
  <div class="home home-festival-38">
    <div class="home-wrapper">
      <div
        class="header"
        :style="{ backgroundColor: searchConfig.bgcolor + '!important' }"
      >
        <div class="title-l">
          <a
            @click="$router.push({ name: 'searchPage' })"
            class="search-bar"
            href="javascript:;"
          >
            <img alt src="../../assets/img/home-change/icon-search.png" />
            <span>搜索商品</span>
          </a>
        </div>
        <div class="title-r">
          <a
            @click="$router.push({ name: 'contactService' })"
            class="service entry-item"
            href="javascript:;"
          >
            <img alt src="./imgs/icon-service.png" />
            <span>客服</span>
          </a>
        </div>
      </div>

      <!-- banners -->
      <div class="acts-entry" v-if="banners.length">
        <swiper :img-list="banners" />
      </div>

      <div class="zq" v-if="actBanners.length">
        <a
          v-for="(item, index) in actBanners"
          :key="index"
          @click="zqGoLink(item)"
          href="javascript:;"
        >
          <img v-lazy="item.img" />
        </a>
      </div>

      <!-- 金刚区 -->
      <div class="jingang-box" v-if="jingangList.length">
        <div
          class="item"
          v-for="item in jingangList"
          :key="item.id"
          @click="zqGoLink(item)"
        >
          <div class="item-img">
            <img :src="item.img" alt />
          </div>
          <div class="item-title">{{ item.title }}</div>
        </div>
      </div>

      <!-- 中秋活动 -->
      <div class="zq" v-if="zq.length">
        <a
          v-for="(item, index) in zq"
          :key="index"
          @click="zqGoLink(item)"
          href="javascript:;"
        >
          <img v-lazy="item.img" />
        </a>
      </div>

      <!-- 本地生活导航 -->
      <div class="zhuanquCont" v-if="zhuanquTit.length">
        <div class="zhuanquNavs">
          <span
            :key="index"
            @click="zhuanqutabs(index)"
            class="nav-item"
            :class="index === zhuanquActive ? 'red' : ''"
            v-for="(item, index) in zhuanquTit"
          >
            {{ item.title }}
          </span>
        </div>

        <!-- 专区列表 -->
        <div class="menus">
          <swipe
            class="worth-buying-today-swiper"
            indicator-color="#FB5A1B"
            @change="zhuanquSwipeChange"
          >
            <swipe-item
              :key="index"
              v-for="(items, index) in localLifeNavs"
              class="menusWrap"
            >
              <div
                v-for="(v, i) in items"
                :key="i"
                class="menusItem"
                @click="navEnteyTaps(v)"
              >
                <img v-lazy="v.img" />
                <span
                  class="title"
                  :class="{ bgcolor: v.bgcolor }"
                  :style="{ backgroundColor: v.bgcolor }"
                  >{{ v.title }}</span
                >
                <wx-open-launch-weapp
                  id="launch-btn"
                  name="applet"
                  v-if="v.to_applet"
                  :username="v.applet_appid"
                  :path="v.url"
                >
                  <script type="text/wxtag-template">
                    <style>.wx-btn {
                        display: block;
                        width: 80px;
                        height: 80px;
                        opacity: 0;
                      }</style>
                    <button class="wx-btn">跳转小程序</button>
                  </script>
                </wx-open-launch-weapp>
              </div>
            </swipe-item>
            <template #indicator>
              <div class="custom-indicator">
                <div
                  :class="{ 'current-item': index == zhuanquSwipeCurrent }"
                  :key="index"
                  class="indicator-item"
                  v-for="(skus, index) in localLifeNavs"
                ></div>
              </div>
            </template>
          </swipe>
        </div>
      </div>

      <!-- 秒杀专区 -->
      <div
        class="flash-sale-act"
        v-if="flashSaleConfig.titleConfig && flashSaleConfig.actConfig"
      >
        <div class="title">
          <div class="title-icon" v-if="flashSaleConfig.titleConfig.img">
            <img :src="flashSaleConfig.titleConfig.img" alt="" />
          </div>
          <div class="title-text">{{ flashSaleConfig.titleConfig.title }}</div>
          <div class="title-tag">
            <div class="tag-icon">
              <img src="./imgs/icon-alarm-clock.png" alt="" />
            </div>
            <div class="tag-text">
              {{ flashSaleConfig.titleConfig.subtitle }}
            </div>
          </div>
        </div>
        <flash-sale :actConfig="flashSaleConfig.actConfig" />
      </div>

      <!-- 特价团购轮播区 -->
      <div
        class="group-buying"
        v-if="groupBuyingSwipe.list.length || groupBuyingSwipe.titleConfig"
      >
        <div class="title" v-if="groupBuyingSwipe.titleConfig">
          <img :src="groupBuyingSwipe.titleConfig.img" alt="" />
          <span>{{ groupBuyingSwipe.titleConfig.title }}</span>
        </div>
        <div v-if="groupBuyingSwipe.list.length">
          <swipe :autoplay="3000" :show-indicators="false">
            <swipe-item
              v-for="(item, index) in groupBuyingSwipe.list"
              :key="index"
            >
              <div class="group-buying-banner" @click="jumpColumnPage(item)">
                <img :src="item.img" alt="" />
              </div>
            </swipe-item>
          </swipe>
        </div>
      </div>

      <!-- 福利秒杀，有选好货 -->
      <div class="good-goods">
        <!-- 会员尊享 实惠购物 -->
        <div
          class="worth-buying-today"
          v-if="worthBuyingTodayGoods.length || audioRights.length"
        >
          <div
            :class="{ 'act-left': audioRights.length }"
            v-if="worthBuyingTodayGoods.length"
          >
            <div class="goods-hdtit">
              <!-- <img src="../assets/img/home-change/icon-welfare.png" alt="" /> -->
              <!-- 春节换肤icon -->
              <!-- <img src="../../assets/img/skin/home-01.png" /> -->
              <!-- 38 -->
              <img src="./imgs/icon-second.png" />
              <div class="title" v-html="worthBuyingTodayConfig.title"></div>
            </div>

            <div
              :key="i"
              class="local-nav"
              v-for="(columns, i) in worthBuyingTodayGoods"
            >
              <swipe
                :autoplay="3000"
                :ref="'worthSwiper' + i"
                @change="swipeChange"
                class="worth-buying-today-swiper"
                indicator-color="#FF5555"
                v-if="i == currentTodayNavIndex"
                :width="itemWidth"
              >
                <swipe-item
                  :key="index"
                  v-for="(skus, index) in columns.sku_list"
                >
                  <div class="tab-content">
                    <a
                      :key="index"
                      @click="jumpMobileZone(columns)"
                      class="goods-details"
                      href="javascript:;"
                      v-for="(sku, index) in skus"
                    >
                      <div class="goods-img van-hairline--surround">
                        <img alt v-lazy="sku.pic_url" />
                      </div>
                      <div class="goods-intro">
                        <div class="goods-price">
                          ¥<em>{{
                            sku.activity
                              | salePrice(sku.equity, sku.market_price)
                          }}</em>
                        </div>
                        <div
                          class="normal-price"
                          v-if="
                            sku.activity.discount !== sku.market_price &&
                              sku.equity.discount !== sku.market_price
                          "
                        >
                          <del>¥{{ sku.market_price }}</del>
                        </div>
                      </div>
                    </a>
                  </div>
                </swipe-item>
                <template #indicator>
                  <div class="custom-indicator" style="display: none">
                    <div
                      :class="{
                        'current-item': index === currentSwipe.current
                      }"
                      :key="index"
                      class="indicator-item"
                      v-for="(skus, index) in columns.sku_list"
                    ></div>
                  </div>
                </template>
              </swipe>
            </div>
          </div>
          <div
            :class="{ 'act-right': audioRights.length }"
            v-if="audioRights.length"
          >
            <div class="goods-hdtit">
              <img src="./imgs/icon-opt.png" alt="" />
              <div class="title" v-html="audioConfig.title"></div>
            </div>

            <div
              :key="i"
              style="height: 2.12rem"
              @click="zqGoLink(audioRights[0])"
            >
              <img v-lazy="audioRights[0].img" />
            </div>
          </div>
        </div>

        <!-- 本地权益入口 -->
        <div class="local-discount" v-if="localDiscountNavs.length">
          <div class="title" v-html="localDiscountConfig.title"></div>
          <div class="lcoal-columns">
            <van-tabs
              :border="false"
              animated
              background="transparent"
              class="local-navs"
              color="#FF6B04"
              line-width="0"
              swipeable
              title-active-color="#FF6B04"
              title-inactive-color="#404040"
              v-model="currentLocalNavIndex"
            >
              <van-tab
                :key="index"
                :title="configer.title"
                class="local-nav"
                title-style
                v-for="(configer, index) in localDiscountNavs"
              >
                <div class="tab-content">
                  <a
                    :key="index"
                    @click="jumpLocalLife(configer)"
                    class="goods-details"
                    href="javascript:;"
                    v-for="(sku, index) in configer.sku_list.items"
                    v-show="index < 6"
                  >
                    <div class="goods-img van-hairline--surround">
                      <img alt v-lazy="sku.main_image" />
                    </div>
                    <div class="goods-intro">
                      <div class="goods-name van-multi-ellipsis--l2">
                        {{ sku.title }}
                      </div>
                      <div class="goods-price">
                        <template v-if="sku.type === 1">
                          <div class="column-gold">
                            {{ sku.point }}
                            <i>盟豆</i>
                          </div>
                          <div class="dis-in gold-dis-in">
                            <i>会员0元领</i>
                          </div>
                        </template>
                        <template v-else-if="sku.type === 2">
                          <div class="column-price">
                            ¥<em>{{ sku.money }}</em>
                          </div>
                          <div class="dis-in" v-if="sku.member_money !== 0">
                            <i>会员省</i>
                            <span>{{ sku.member_money }}元</span>
                          </div>
                        </template>
                      </div>
                      <div class="store-name van-ellipsis">
                        {{ sku.shopInfo.name }}
                      </div>
                    </div>
                  </a>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>

        <!-- 优惠 -->
        <div class="snap-up-today" v-if="snapUpList.length">
          <a
            :key="index"
            @click="jumpSnapUp(configer)"
            class="snap-up-today-column"
            href="javascript:;"
            v-for="(configer, index) in snapUpList"
          >
            <div class="snap-up-wrapper">
              <img alt v-lazy="configer.img" />
            </div>
          </a>
        </div>

        <!-- 游戏banner -->
        <div class="game-entry" v-if="gameBanners.length">
          <Swiper :img-list="gameBanners" />
        </div>

        <!-- 试听权益 -->
        <div class="audio-rights">
          <div
            :key="index"
            class="audio-rights-wrapper"
            v-for="(skus, index) in audioRights"
          >
            <div class="title-wrapper">
              <div class="goods-hdtit">
                <img src="../../assets/img/home-change/icon-goodGoods.png" />
                <div class="title" v-html="audioConfig.title"></div>
              </div>
            </div>
            <div :key="index" v-for="(skuGroup, index) in skus.sku_list">
              <div class="goods-list">
                <button
                  :key="index"
                  @click="columnSortJump(skus, sku.item_id, sku.sku_id)"
                  class="goods-item"
                  v-for="(sku, index) in skuGroup"
                >
                  <div class="sku-img van-hairline--surround">
                    <img v-lazy="sku.pic_url" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 会员福利 -->
      <div class="welfare-entry" v-if="memberWelfares.length">
        <div
          :key="index"
          class="title-wrapper"
          v-for="(welfare, index) in memberWelfares"
        >
          <button @click="navEnteyTaps(welfare)" class="welfare-img">
            <img alt v-lazy="welfare.img" />
          </button>
        </div>
      </div>

      <!-- 移动专区 -->
      <div class="move-container" v-if="ydArea.length">
        <div
          class="item vue-gather-click"
          :vue-gather-categray="index ? 'bghomeRightmarket' : 'bghomeBusiness'"
          :vue-gather-value="`${index}_${ydzq.title}`"
          v-for="(ydzq, index) in ydArea"
          :key="index"
          @click="jumpMobileZone(ydzq)"
        >
          <div class="title" v-if="ydzq.title">{{ ydzq.title }}</div>
          <img alt v-lazy="ydzq.img" />
        </div>
      </div>

      <!-- 99包邮赚钱 -->
      <div
        class="free-shopping"
        v-if="
          freeShoppingConfig.columnConfig.length ||
            freeShoppingConfig.titleConfig
        "
      >
        <div class="title" v-if="freeShoppingConfig.titleConfig">
          <img src="./imgs/icon-shop.png" alt="" />
          <span>{{ freeShoppingConfig.titleConfig.title }}</span>
        </div>
        <div v-if="freeShoppingConfig.columnConfig.length">
          <goods-column
            :columnConfig="freeShoppingConfig.columnConfig"
            :titleConfig="freeShoppingConfig.titleConfig"
          ></goods-column>
        </div>
      </div>
      <!-- 全量商品商品 -->
      <column-goods :columns="goodsColumn" />
    </div>
    <dialogs
      :showCancel="false"
      @confrim-handler="confrimHandler"
      v-model="fuliShow"
    >
      <p slot="msg">该产品属于员工福利！<br />您不符合购买资格。</p>
    </dialogs>
    <popup
      @click-overlay="closePopupModel"
      class="event-model"
      v-model="showPopupModel"
    >
      <button @click="jumpPopupModelDetails" class="event-model-details">
        <button
          @click.stop="closePopupModel"
          class="event-model-close"
        ></button>
        <img :src="popupInfo.img" />
      </button>
    </popup>
    <popup
      :close-on-click-overlay="false"
      class="gitpop"
      v-model="popupGiftIsShow"
    >
      <img :src="popupGift.img" />
    </popup>
    <div id="origin-wrapper"></div>
    <!-- 回到顶部 -->
    <back-to-top :show-cart="false" />
  </div>
</template>

<script>
import GoodsColumn from './components/goodsColumn'
import Dialogs from '@/components/Dialog'
import Swiper from '@/components/SwiperCommon'
import BackToTop from '@/components/BackToTop'
import flashSale from './components/flashSale.vue'
import ColumnGoods from './components/column-goods.vue'

import { Popup, Tab, Tabs, Swipe, SwipeItem } from 'vant'
import { mapState, mapActions, mapMutations } from 'vuex'
import api from '@/utils/api'
import { arrayHandle, isApplet } from '@/utils/common'
import { wechat } from '@/utils/wechat'
let flag = false
export default {
  name: 'home',
  components: {
    flashSale,
    GoodsColumn,
    Popup,
    Dialogs,
    BackToTop,
    Swiper,
    VanTab: Tab,
    VanTabs: Tabs,
    Swipe,
    SwipeItem,

    ColumnGoods
  },
  data () {
    return {
      flashSaleConfig: {
        titleConfig: null,
        actConfig: null
      },
      groupBuyingSwipe: {
        titleConfig: null,
        list: []
      },
      freeShoppingConfig: {
        titleConfig: null,
        columnConfig: []
      },
      searchConfig: {
        bgcolor: ''
      },
      popupGift: {
        img: ''
      },
      popupGiftIsShow: false,
      showPopupModel: false,
      popupInfo: {
        img: ''
      },
      fuliShow: false,
      testarr: [
        { img: '../assets/img/home-change/icon-search.png' },
        { img: '../assets/img/home-change/icon-onlineServer.png' }
      ],
      tabBackground: 'none',
      active: 0,
      localSelectData: {},
      ydArea: [],
      zq: [],
      dailyAct: {
        img: ''
      },
      mainNavs: [],
      zhuanquTit: [],
      zhuanquActive: 0,
      banners: [],
      jingangList: [],
      actBanners: [],
      localDiscountConfig: {
        title: ''
      },
      localDiscountNavs: [],
      memberWelfares: [],
      currentLocalNavIndex: 0,
      worthBuyingTodayConfig: {
        title: ''
      },
      keepList: {
        localLifeList: [],
        mallList: []
      },
      worthBuyingTodayGoods: [],
      currentSwipes: [
        {
          current: 0
        }
      ],
      currentTodayNavIndex: 0,
      snapUpList: [],
      gameBanners: [],
      audioConfig: {
        title: ''
      },
      audioRights: [],
      audioSwipeCurrent: 0,
      rightsConfig: {
        title: ''
      },
      rightsList: [],
      localLifeRights: [],

      cityChangeStatus: false,
      loadLocalStatus: false,
      localCouponFinished: false,
      footerConfiger: {
        sku_list: []
      },
      columnConfig: {
        sku_list: []
      },
      dataList: [],
      zhuanquSwipeCurrent: 0,
      goodsColumn: []
    }
  },
  computed: {
    ...mapState('store', [
      'showHomeModel',
      'cityCode',
      'Authorization',
      'localtionInfo',
      'userInfo',
      'clueterInfo',
      'homeGiftShow'
    ]),
    itemWidth () {
      return (
        ((document.documentElement.clientWidth || document.body.clientWidth) /
          156) *
        35
      )
    },
    audioSwipeItemWidth () {
      return (
        ((document.documentElement.clientWidth || document.body.clientWidth) /
          750) *
        560
      )
    },
    currentSwipe () {
      return this.currentSwipes[this.currentTodayNavIndex]
    },
    localLifeNavs () {
      return this.zhuanquTit[this.zhuanquActive].list
    }
  },
  watch: {
    cityCode () {
      this.initData()
      this.$toast.loading('正在切换城市,请稍后...')
      this.getHomeVersionJSON()
    }
  },
  filters: {
    // 价格展示
    salePrice (activity, member, market) {
      if (activity) {
        return activity.discount
      } else if (member) {
        return member.discount
      } else {
        return market
      }
    }
  },

  created () {
    wechat({
      fullPath: this.$route.fullPath,
      name: this.$route.name,
      title: '',
      desc: ``,
      imgUrl: ''
    })
    this.$toast.loading('正在加载,请稍后...')
    this.getHomeVersionJSON()
  },

  mounted () {
    window.originApi({})
  },

  methods: {
    ...mapActions('store', ['getIsShowHomeModel']),
    ...mapMutations('store', ['updateHomeGiftShow']),

    // 弹窗跳转
    async jumpPopupModelDetails () {
      if (flag) {
        return false
      }
      flag = true
      this.closePopupModel()
      await api.ActconfigJumpDetails(this.popupInfo)
    },
    // 关闭弹窗
    closePopupGift () {
      this.showPopupModel = false
      this.updateHomeGiftShow(true)
    },
    closePopupModel () {
      this.showPopupModel = false
      this.getIsShowHomeModel(true)
    },
    confrimHandler () {
      this.fuliShow = false
    },
    tabScroll (e) {
      if (e.isFixed === true) {
        this.tabBackground = '#FFF'
      } else {
        this.tabBackground = 'none'
      }
    },
    // 轮播切换
    zhuanquSwipeChange (i) {
      this.zhuanquSwipeCurrent = i
    },
    onClickDisabled () {
      this.$router.push('/classify')
    },

    // 初始化数据
    initData () {
      const data = {
        flashSaleConfig: {
          titleConfig: null,
          actConfig: null
        },
        groupBuyingSwipe: {
          titleConfig: null,
          list: []
        },
        freeShoppingConfig: {
          titleConfig: null,
          columnConfig: []
        },
        searchConfig: {
          bgcolor: ''
        },
        localSelectData: {},
        ydArea: [],
        zq: [],
        dailyAct: {
          img: ''
        },
        popupGiftIsShow: false,
        popupGift: {
          img: ''
        },
        showPopupModel: false,
        popupInfo: {
          img: ''
        },
        mainNavs: [],
        zhuanquTit: [],
        zhuanquActive: 0,
        banners: [],
        jingangList: [],
        actBanners: [],
        localDiscountConfig: {
          title: ''
        },
        localDiscountNavs: [],
        memberWelfares: [],
        currentLocalNavIndex: 0,
        worthBuyingTodayConfig: {
          title: ''
        },
        worthBuyingTodayGoods: [],
        currentSwipes: [
          {
            current: 0
          }
        ],
        currentTodayNavIndex: 0,
        snapUpList: [],
        gameBanners: [],
        audioConfig: {
          title: ''
        },
        audioRights: [],
        audioSwipeCurrent: 0,
        rightsConfig: {
          title: ''
        },
        rightsList: [],
        localLifeRights: [],
        loadLocalStatus: false,
        localCouponFinished: false,
        footerConfiger: {
          sku_list: []
        },
        dataList: [],
        zhuanquSwipeCurrent: 0,
        goodsColumn: []
      }
      Object.assign(this.$data, data)
    },

    // 专题切换
    zhuanqutabs (index) {
      if (this.zhuanquActive !== index) {
        this.zhuanquActive = index
        this.zhuanquSwipeCurrent = 0
      }
    },

    async jumpColumnPage (configer) {
      if (flag) {
        return false
      }
      flag = true
      if (configer.sku) {
        const goodsid = configer.sku.item_id
        const skuid = configer.sku.sku_id
        const platform = configer.sku.platform
        const type = configer.sku.item_type
        await api.routeJump({ goodsid, skuid, platform, type })
      } else {
        await api.configJumpDetails(configer)
      }
      flag = false
    },
    // 栏目配置跳转
    async navEnteyTaps (configer) {
      if (configer.cluster_id) {
        if (this.Authorization) {
          if (this.clueterInfo.includes(Number(configer.cluster_id))) {
            await api.configJumpDetails(configer)
          } else {
            this.$toast('抱歉，您没有权限')
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      } else {
        await api.configJumpDetails(configer)
      }
    },

    // 今日限量抢
    jumpSnapUp (config) {
      if (config.is_href) {
        location.href = config.url
      } else {
        this.jumpDetails(config.spuid, config.skuid, config.goods_type)
      }
    },

    // 正常商品详情跳转
    jumpDetails (goodsid, skuid, type) {
      api.routeJump({ goodsid, skuid, type })
    },

    // 栏目商品排序跳转
    async columnSortJump (configer, gid, sid) {
      if (configer.cluster_id) {
        if (this.Authorization) {
          if (this.clueterInfo.includes(Number(configer.cluster_id))) {
            await api.homeConfigJump(configer, gid, sid)
          } else {
            this.$toast('抱歉，您没有权限')
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      } else {
        await api.homeConfigJump(configer, gid, sid)
      }
    },

    // 本地生活商品跳转
    async jumpLocalLife (config, sku) {
      if (sku) {
        location.href = `${process.env.VUE_APP_SHOP_DOMAIN}cashDetail?cardId=${sku.id}&shopId=${sku.shop_id}`
      } else {
        location.href = config.url
      }
    },

    finishedHandler (status) {
      this.localCouponFinished = status
    },

    // 底部导航跳转
    footerNavHandler (config) {
      if (config.isLink) {
        location.href = config.path
      } else {
        this.$router.push({ name: config.path })
      }
    },
    // 获取首页数据
    async getHomeVersionJSON () {
      const base = 'company'
      const data = await api.getJsonVersion(base).catch(err => {
        this.$toast.clear()
        throw Error(err)
      })
      this.$toast.clear()
      this.loadLocalStatus = true
      const searchConfig = data[`${base}-search`]
      this.searchConfig = (searchConfig && searchConfig.data[0]) || { bgcolor: '' }
      const p1 = data[`${base}-1`]
      if (p1 && p1.data && p1.data.length) {
        this.dailyAct = p1.data[0]
      }
      const p2 = data[`${base}-2`]
      this.banners = p2 ? p2.data : []
      const p22 = data[`${base}-2-2`]
      this.zq = p22 ? p22.data : []
      const worker = data[`${base}-worker-zone-1`]
      let workerList =
        data[`${base}-worker-zone-2`] &&
        data[`${base}-worker-zone-2`].data.length &&
        data[`${base}-worker-zone-2`].data
      if (worker && worker.data && worker.data.length && workerList) {
        const result = {
          ...worker.data[0],
          list: []
        }
        workerList = workerList.filter(item => {
          return isApplet() ? item : item.to_applet !== '1'
        })
        for (let i = 0; i < workerList.length; i += 4) {
          result.list.push(workerList.slice(i, i + 4))
        }
        this.zhuanquTit.push(result)
      }

      const companies = data[`${base}-companies-zone-1`] || []
      const companiesList =
        data[`${base}-companies-zone-2`] &&
        data[`${base}-companies-zone-2`].data.length &&
        data[`${base}-companies-zone-2`].data
      if (companies && companies.data && companies.data.length && companiesList) {
        const result = {
          ...companies.data[0],
          list: []
        }
        for (let i = 0; i < companiesList.length; i += 4) {
          result.list.push(companiesList.slice(i, i + 4))
        }
        this.zhuanquTit.push(result)
      }

      const p3 = data[`${base}-3`]
      this.jingangList = p3 ? p3.data : []
      const p4c = data[`${base}-4`]
      if (p4c && p4c.data && p4c.data.length) {
        this.worthBuyingTodayConfig = p4c.data[0]
      }
      const actBanners = data[`${base}-act-banner`]
      this.actBanners = actBanners ? actBanners.data : []
      const p4d = data[`${base}-4-1`]
      this.worthBuyingTodayGoods = p4d ? p4d.data.map((v, i) => {
        this.currentSwipes.push({ current: 0 })
        v.sku_list =
          v.sku_list.length &&
          arrayHandle(
            v.sku_list.length > 9 ? v.sku_list.slice(0, 9) : v.sku_list,
            1
          )
        return v
      }) : []
      /* 秒杀专区 */
      this.flashSaleConfig.titleConfig = (data.hasOwnProperty(`${base}-flash-sale-1`) && data[`${base}-flash-sale-1`].data[0]) || null
      this.flashSaleConfig.actConfig = (data.hasOwnProperty(`${base}-flash-sale-2`) && data[`${base}-flash-sale-2`].data[0]) || null
      /* 团购专区 */
      this.groupBuyingSwipe.titleConfig = (data.hasOwnProperty(`${base}-group-buying-1`) && data[`${base}-group-buying-1`].data[0]) || null
      this.groupBuyingSwipe.list = (data.hasOwnProperty(`${base}-group-buying-2`) && data[`${base}-group-buying-2`].data) || []
      const ydzq = data[`${base}-3-2`]
      this.ydArea = ydzq ? ydzq.data : []
      const p5 = data[`${base}-5`]
      this.snapUpList = p5 ? p5.data : []
      const p6 = data[`${base}-6`]
      this.gameBanners = p6 ? p6.data : []
      const p7 = data[`${base}-7`]
      this.memberWelfares = p7 ? p7.data : []
      /* 99包邮 */
      this.freeShoppingConfig.titleConfig = (data.hasOwnProperty(`${base}-free-shipping-1`) && data[`${base}-free-shipping-1`].data[0]) || null
      this.freeShoppingConfig.columnConfig = (data.hasOwnProperty(`${base}-free-shipping-2`) && data[`${base}-free-shipping-2`].data) || []
      const p8c = data[`${base}-8`]
      if (p8c && p8c.data && p8c.data.length) {
        this.audioConfig = p8c.data[0]
      }
      const p8d = data[`${base}-8-1`]
      this.audioRights = p8d ? p8d.data : []
      const goodsColumn = data[`${base}-9`]
      this.goodsColumn = goodsColumn ? goodsColumn.data : []
      const p10 = data[`${base}-4-2`]
      if (p10 && p10.data && p10.data.length) {
        this.localSelectData = p10.data[0]
      }
      const p11 = data[`${base}-popup`]
      if (p11 && p11.data && p11.data.length) {
        this.popupInfo = p11.data[0]
      }
      const p12 = data[`${base}-popup2`]
      if (p12 && p12.data && p12.data.length) {
        this.popupGift = p12.data[0]
      }
      if (this.Authorization) {
        if (this.popupInfo && this.popupInfo.img) {
          this.showPopupModel = !this.showHomeModel
        }
      } else {
        if (this.popupGift && this.popupGift.img) {
          this.popupGiftIsShow = !this.homeGiftShow

          setTimeout(() => {
            this.updateHomeGiftShow(true)
            this.popupGiftIsShow = false
          }, (this.popupGift.ext_json - 0) * 1000)
        }
      }
    },

    // 轮播切换
    swipeChange (i) {
      this.currentSwipes[this.currentTodayNavIndex].current = i
    },
    audioSwipeChange (i) {
      this.audioSwipeCurrent = i
    },
    jumpMobileZone (item) {
      api.configJumpDetails(item)
    },
    // 活动跳转
    zqGoLink (item) {
      if (item.cluster_id) {
        if (this.Authorization) {
          if (this.clueterInfo.includes(Number(item.cluster_id))) {
            api.configJumpDetails(item)
          } else {
            this.$toast('抱歉，您没有权限')
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      } else {
        api.configJumpDetails(item)
      }
    }

  }
}
</script>

<style lang="less">
@import './styles/homeRed.less';

// .van-swipe__indicators {
//   bottom: 0 !important;
// }
// .home .van-tab--disabled {
//   color: #646566 !important;
// }
// .home .van-tab--active {
//   font-size: 16px !important;
//   font-weight: bold !important;
//   flex: 1 0 auto !important;
// }
// .home .van-tabs__line {
//   width: 6% !important;
//   background: linear-gradient(270deg, #f0e1ce 26%, #dcbfa0 95%);
// }
.local-navs,
.worth-buying-today-navs {
  .van-tab {
    background: #f9f9f9;
    border-radius: 30px;
    flex: 0 1 auto;
    min-width: 1.5rem;
    padding: 0 0.2rem;
    height: 0.54rem;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.2rem;
    font-size: @fz24;
    &:first-child {
      margin-left: 0.1rem;
    }
  }

  // .van-tab--active {
  //   background-color: #ffedc5;
  // }
}
.worth-buying-today-navs {
  .van-tabs__nav {
    justify-content: flex-start;
  }
  .van-tab--active {
    background-color: #ffeaec;
  }
}
</style>
<style lang="less" scoped>
.stickyTabs {
  /deep/ .van-sticky--fixed {
    // padding-bottom: .1rem;
    border-bottom: 0.02rem solid #d9d9d9;
  }
}
.footConTab {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0.3rem 0 0.2rem 0;
}
.footConTab a {
  font-size: 0.32rem;
  color: #000;
}
.footConTab a.active {
  border-bottom: 0.1rem solid rgba(210, 177, 143, 1);
}
.zq {
  max-width: 100%;
  height: auto;
}
.zhuanquCont {
  padding: 0.18rem 0;
  margin: 0.2rem;
  background: #fff;
  border-radius: 0.1rem;
  font-size: 0.22rem;
  color: #fff;
}
.zhuanquNavs {
  margin-bottom: 0.2rem;
  span {
    display: inline-block;
    padding: 0 0.23rem;
    height: 0.52rem;
    line-height: 0.52rem;
    color: #737373;
    font-size: 0.28rem;
  }
  .red {
    position: relative;
    color: #343434;
    font-weight: bold;
  }
  .red::after {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    content: '';
    width: 0.48rem;
    height: 0.05rem;
    background: rgb(232, 211, 180);
    border-radius: 0.03rem;
  }
}
.menus {
  width: 100%;
  .menusItem {
    position: relative;
    width: 25%;
    height: 2.2rem;
    display: inline-block;
    text-align: center;
    #launch-btn {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      opacity: 0;
    }
  }
  img {
    margin: 0 auto;
    display: block;
    width: 1.58rem;
    height: 1.58rem;
  }
  .title {
    color: #333;
    position: absolute;
    left: 50%;
    bottom: 0.4rem;
    transform: translateX(-50%);
    width: 1.2rem;
    height: 0.42rem;
    line-height: 0.42rem;
    text-align: center;
    border-radius: 0.21rem;
  }
}
.good-goods {
  margin: 0 0.2rem;
  position: relative;
  overflow: hidden;
}

.good-goods > div {
  width: 50%;
  height: 3.2rem;
  box-sizing: border-box;
}
.goods-hdtit {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0.2rem;
}
.goods-hdtit img {
  width: 0.18rem;
  height: 0.25rem;
}
.home {
  background-color: #f3f3f3;
}
.home-wrapper {
  min-height: 13.34rem;
  margin-bottom: 0.5rem;
}
// 头部
.header {
  padding: 0 0.3rem;
  height: 1rem;
  z-index: 99;
  background: rgba(39, 43, 58, 1);
  .flex-between;
  .title-l,
  .title-r {
    font-size: @fz20;
    .flex-center;
  }
  .search-bar span {
    display: inline-block;
  }
  .search-bar img {
    position: absolute;
    left: 0;
  }
  .search-bar {
    justify-content: center;
    position: relative;
    width: 5.8rem;
    // width: 3.6rem;
    height: 0.64rem;
    // margin-left: 0.24rem;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 30px;
    font-size: @fz22;
    color: @c80;
    img {
      width: 0.32rem;
      height: 0.31rem;
      vertical-align: middle;
      padding: 0 0.2rem;
    }
  }
  .local-city {
    color: #727272;
    font-size: 0.22rem;
    .local-city-triangle {
      width: 0.15rem;
      height: 0.15rem;
    }
  }
  .entry-item {
    .flex-column-center;
    color: @base;
    margin-left: 0.2rem;
    flex-direction: row;
    &:first-child {
      margin-left: 0.05rem;
    }
    img {
      width: 0.38rem;
      height: 0.38rem;
      padding-bottom: 0.04rem;
      margin-right: 0.05rem;
    }
    span {
      color: #fff;
    }
  }
}

// 导航
.nav-entry {
  padding: 0.2rem 0.2rem;
  background-color: rgba(255, 255, 255, 0.69);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .nav-item {
    position: relative;
    font-size: 0.26rem;
    color: #4a4b5b;
    flex: 1;
    .flex-column;
    align-items: center;
    .nav-icon {
      width: 0.9rem;
      height: 0.9rem;
      border-radius: 50%;
      overflow: hidden;
      margin-bottom: 0.05rem;
      img {
        object-fit: contain;
      }
    }
    .title {
      // white-space: nowrap;
      padding-top: 0.05rem;
    }
    .sub-title {
      position: absolute;
      right: 0.25rem;
      top: 0;
      transform: translate(50%, -10%);
      font-size: 0.18rem;
      color: #fff;
      .flex-center;
      max-width: 0.6rem;
      overflow: hidden;
      white-space: nowrap;
      padding: 0rem 0.08rem;
      background-color: #ee6c32;
      border-radius: 10px;
    }
  }
}

// 本地导航
.local-navs-entry {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  padding-top: 0.2rem;
  // background-color: #fff;
  .nav-item {
    width: 20%;
    padding-bottom: 0.34rem;
    position: relative;
    font-size: 0.26rem;
    color: #4a4b5b;
    .flex-column-center;
    .nav-icon {
      width: 0.9rem;
      height: 0.9rem;
      margin-bottom: 0.22rem;
      img {
        object-fit: contain;
      }
    }
  }
}

// 广告轮播
.acts-entry {
  border-radius: 0.1rem;
  margin: 0.2rem;
  width: 7.1rem;
  // height: 3.8rem;
  overflow: hidden;
  background-color: #fff;
}
.acts-entry .swiper img {
  max-width: 7.1rem;
}

.jingang-box {
  margin: 0.2rem;
  display: flex;
  flex-wrap: wrap;

  .item {
    flex: 0 0 20%;
    margin: 0.1rem 0;

    &-img {
      width: 0.78rem;
      height: 0.78rem;
      margin: 0 auto;
    }
    &-title {
      margin-top: 0.1rem;
      font-size: 0.24rem;
      color: #342f28;
      text-align: center;
    }
  }
}
// 福利
.welfare-entry img {
  width: 100%;
  height: auto;
}
.welfare-entry {
  // margin-top: 0.2rem;
  padding: 0.2rem;
  // background-color: #fff;
  .title-wrapper {
    .title {
      font-size: @fz32;
      color: @base;
      font-weight: bold;
    }
    .sub-title {
      font-size: @fz24;
      color: #81664f;
      padding: 0.14rem 0 0.2rem;
    }
  }

  .welfare-img {
    width: 100%;
    height: 1.72rem;
  }
  .goods-wrapper {
    .flex-between;
    .first-goods {
      width: 3.36rem;
      height: 3.44rem;
    }
    .goods-item-wrapper {
      height: 3.44rem;
      .flex-column-between;
      .goods-item {
        width: 3.4rem;
        height: 1.65rem;
        img {
          object-fit: contain;
        }
      }
    }
  }
}

.move-container {
  margin: 0.2rem;
  padding: 0.2rem 0.2rem 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  background: #ffffff;
  border-radius: 0.1rem;
  .item {
    width: 48.6%;
    margin-bottom: 0.2rem;
    .title {
      font-size: 0.28rem;
      color: #404040;
      padding-left: 0.05rem;
      margin-bottom: 0.2rem;
    }

  }
}

.local-discount,
.worth-buying-today {
  width: 100% !important;
  margin-top: 0.2rem;
  padding: 0.2rem;
  background-color: #fff;
  display: flex;
  .act-left,
  .act-right {
    width: 50%;
  }
  .title {
    font-size: @fz34;
    color: @base;
    padding-left: 0.1rem;
    // padding-bottom: 0.2rem;
  }
  .tab-content {
    // .flex-between-wrap;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .goods-details {
    width: 100%;
    .flex-column-center;
    // &:nth-child(3n-1) {
    // margin: 0 0.2rem;
    // }
  }
  .goods-intro {
    width: 1.4rem;
  }
  .goods-img {
    width: 1.4rem;
    height: 1.4rem;
    img {
      object-fit: contain;
    }
  }
  .goods-name {
    font-size: @fz26;
    color: @base;
    margin: 0.15rem 0;
    font-weight: 500;
  }
  .goods-price {
    color: #ff7845;
    font-size: @fz24;
    em {
      font-size: @fz26;
    }
  }
  .store-name {
    color: #848484;
    font-size: @fz22;
    padding-top: 0.1rem;
  }
}

//本地钜惠
.local-discount {
  align-items: center;
  .goods-details {
    margin-bottom: 0.3rem;
  }
  .column-price {
    width: 100%;
    color: #ff7845;
    font-size: @fz24;
    del {
      margin-left: 0.1rem;
      font-size: 0.22rem;
      color: #808080;
    }
    b {
      font-size: @fz28;
      font-weight: 600;
    }
  }
  .column-gold {
    font-size: 0.28rem;
    color: #ff7845;
    i {
      font-size: 0.22rem;
      color: #808080;
    }
  }
  .dis-in {
    position: relative;
    margin-top: 0.12rem;
    font-size: 0.2rem;
    display: table;
    .hairline-surround(@color: #f3e3d4; @radius: 0.04rem);
    color: #a27954;
    i {
      font-weight: 500;
      position: relative;
      z-index: 2;
      padding: 0 0.03rem;
      text-align: center;
      display: inline-block;
    }
    span {
      font-weight: 500;
      padding: 0 0.05rem;
      background: #fff;
      display: inline-block;
    }
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 0.67rem;
      bottom: 0;
      background: #f3e3d4;
    }
  }
  .gold-dis-in {
    &:before {
      width: 100%;
    }
  }
}

// 今日值得买
.worth-buying-today {
  // margin: 0.2rem 0;
  margin-top: 0;
  .goods-intro {
    .goods-price {
      color: rgba(188, 118, 80, 1);
      padding-bottom: 0.03rem;
    }
    .normal-price {
      color: #98999c;
      font-size: @fz22;
      padding-bottom: 0.1rem;
      transform: scale(0.95);
      margin-left: -0.025rem;
    }
  }
}
.worth-buying-today-swiper {
  // padding-bottom: 0.5rem;
  .custom-indicator {
    position: absolute;
    bottom: 0.2rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    .indicator-item {
      width: 0.3rem;
      height: 0.06rem;
      background-color: #f3f3f3;
      border-radius: 0.03rem;
      // margin-left: 0.05rem;
    }
    .current-item {
      width: 0.14rem;
      background-color: rgb(232, 211, 180);
      border-radius: 0.03rem;
    }
  }
}

// 限量抢
.snap-up-today {
  background-color: #fff;
  .snap-up-wrapper {
    width: 100%;
    height: 3.96rem;
    img {
      object-fit: contain;
    }
  }
}

// 游戏入口
.game-entry {
  margin-top: 0.2rem;
  width: 100%;
  height: 2.8rem;
  overflow: hidden;
  background-color: #ccc;
}

// 视听权益
.audio-rights {
  display: none;
  width: 100% !important;
  margin-top: 0;
  // padding: 0.34rem 0.3rem 0rem;
  background-color: #fff;
  .title-wrapper {
    .flex-between;
    // padding-bottom: 0.25rem;
    .title {
      font-size: @fz34;
      color: @base;
      margin-left: 0.1rem;
      // font-weight: bold;
    }
    .more {
      color: #979797;
      font-size: @fz24;
      .flex-center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        padding-left: 0.1rem;
        object-fit: contain;
      }
    }
  }
  .audio-swipe {
    padding-bottom: 0.1rem;
    .custom-indicator {
      position: absolute;
      bottom: 0.2rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      .indicator-item {
        width: 0.1rem;
        height: 0.06rem;
        background-color: #ebebeb;
        margin-left: 0.05rem;
      }
      .current-item {
        width: 0.3rem;
        background-color: #ff5555;
      }
    }
  }
  .goods-list {
    display: flex;
    padding-bottom: 0.4rem;
    .goods-item {
      width: 1.4rem;
      box-shadow: 0px 0.02rem 0.16rem 0px rgba(202, 202, 202, 0.33);
      border-radius: 8px;
      margin-right: 0.35rem;
      // &:nth-child(2n) {
      //   margin-left: 0.2rem;
      // }

      .sku-img {
        width: 1.4rem;
        height: 1.4rem;
      }
      .sku-name {
        padding: 0 0.06rem;
        padding-top: 0.14rem;
        font-size: @fz24;
        color: @base;
      }
      .sku-price {
        padding: 0.25rem 0.1rem 0.15rem;
        text-align: left;
        .member-price {
          em {
            font-size: @fz22;
          }
          .flex-between;
          color: #ff5555;
          font-size: @fz26;
        }
        .normal-price {
          color: #8d8f92;
          font-size: @fz24;
          padding-bottom: 0.1rem;
        }
      }
    }
  }
}

// 会员免费领
.get-free-entry {
  margin-top: 0.2rem;
  padding: 0.2rem 0;
  background-color: #fff;
  .title {
    font-weight: bold;
    color: @base;
    font-size: @fz34;
    padding: 0rem 0.3rem 0.3rem;
    span {
      color: #ff5768;
    }
  }
}

.local-columns {
  background-color: #fff;
  .local-life-rights {
    padding: 0 0.25rem;
    .rights-sku {
      width: 3.4rem;
      .sku-img {
        width: 3.4rem;
        height: 3.4rem;
      }
      .sku-desc {
        font-size: @fz26;
        color: #483121;
        margin: 0.1rem 0;
      }
      .sku-brands {
        color: #adb1c4;
        font-size: @fz24;
        padding-bottom: 0.4rem;
      }
    }
  }
}

.footer {
  padding: 0.4rem 0;
  .flex-center;
  button {
    width: 3.3rem;
    height: 0.72rem;
    color: #666;
    font-size: @fz24;
    background-color: #fff;
    margin-right: 0.3rem;
    border-radius: 30px;
    &:last-child {
      margin-right: 0;
    }
  }
}

.gitpop {
  width: 100%;
  background: transparent;
  img {
    width: 90%;
    margin: 0 auto;
    display: block;
  }
}
.event-model {
  background-color: transparent;
  &-details {
    position: relative;
    width: 7.28rem;
    height: 8.75rem;
  }
  &-close {
    position: absolute;
    top: 0.6rem;
    right: 0.5rem;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
  }
}
.free-shopping {
  .title {
    display: flex;
    align-items: center;
    background: #fff;
    font-size: 0.32rem;
    font-weight: 500;
    line-height: 0.45rem;
    color: #202020;
    padding: 0.13rem 0.4rem;
    img {
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.18rem;
    }
  }
}
.group-buying {
  margin: 0.2rem 0.24rem;
  .title {
    display: flex;
    align-items: center;
    background: #fff;
    font-size: 0.32rem;
    font-weight: 500;
    line-height: 0.45rem;
    color: #202020;
    padding: 0.2rem 0.26rem;
    img {
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.18rem;
    }
  }
}
.flash-sale-act {
  margin: 0.2rem 0.24rem;
  .title {
    display: flex;
    align-items: center;
    font-size: 0.28rem;
    font-weight: 500;
    line-height: 0.45rem;
    color: #202020;
    padding: 0.2rem 0.26rem;
    .title-icon {
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.18rem;
    }
    .title-text {
      flex: 1;
    }
    .title-tag {
      display: flex;
      align-items: center;
    }
    .tag-text {
      font-size: 0.24rem;
      font-weight: 400;
    }
    .tag-icon {
      width: 0.26rem;
      height: 0.25rem;
    }
  }
}
</style>
<style lang="less">
.worth-buying-today {
  .van-tab__text--ellipsis {
    overflow: visible;
  }
}
</style>
